// import axios from "axios";
// let hostUrl = "https://chart-api.risingx.io";
// import { getCssVariableValue } from "../../utils/utils";

// export async function getChartData(url, symbol, data) {
//   try {
//     console.log(url, symbol, data);
//     const res = await axios.get(`${hostUrl}/candle/${url}?ticker=${symbol}`);
//     const result = res.data.result;

//     data.forEach((list) => {
//       list.array.length = 0; // 배열을 초기화하여 중복 데이터 방지
//     });

//     for (let i = 0; i < result.length; i++) {
//       data.forEach((list) => {
//         list.array.push({
//           time: result[i].time,
//           value: result[i][list.name],
//         });
//       });
//     }
//     // console.log(data);
//     // console.log(res.data.result);
//   } catch (error) {
//     console.log("error", error);
//   }
// }

// export async function getSr(url, symbol, data) {
//   // console.log(url, symbol, data);
//   symbol = symbol.split("USDT")[0];
//   const res = await axios.get(`${hostUrl}/candle/${url}?ticker=${symbol}`);
//   const sr_list = res.data.result;
//   data.forEach((list) => {
//     const { color, title } = setPriceOptions(list.name);
//     list["array"] = {
//       price: Number(sr_list[list.name]),
//       color: color,
//       lineWidth: 2,
//       lineStyle: 2, // LineStyle.Dashed
//       axisLabelVisible: true,
//       title: title,
//     };
//   });
// }

// function setPriceOptions(name) {
//   let firstChar = name.charAt(0);
//   let period = name.slice(-2);
//   // console.log(period);
//   let title = "";
//   let color = "";
//   if (firstChar == "h") {
//     color = getCssVariableValue("--chart-sr-upper");
//   } else {
//     color = getCssVariableValue("--chart-sr-lower");
//   }
//   let text = firstChar == "h" ? "Sell" : "Buy";
//   if (period == "4w") {
//     title = `${text}6`;
//   } else if (period == "3w") {
//     title = `${text}5`;
//   } else if (period == "2w") {
//     title = `${text}4`;
//   } else if (period == "1w") {
//     title = `${text}3`;
//   } else if (period == "2d") {
//     title = `${text}2`;
//   } else if (period == "1d") {
//     title = `${text}1`;
//   }
//   return { color, title };
// }
import axios from "axios";
let hostUrl = "https://chart-api.risingx.io";
// let devConfig.baseUrl = "https://chart-api.blocksquare.tech";
import { getCssVariableValue } from "../../utils/utils";
import { devConfig, chartInstance } from "@/api/baseApi";

export async function getChartData(url, symbol, data) {
  try {
    // console.log(url, symbol, data);
    const res = await axios.get(`${hostUrl}/candle/${url}?ticker=${symbol}`);
    const result = res.data.result;

    data.forEach((list) => {
      list.array.length = 0; // 배열을 초기화하여 중복 데이터 방지
    });

    for (let i = 0; i < result.length; i++) {
      data.forEach((list) => {
        list.array.push({
          time: result[i].time,
          value: result[i][list.name],
        });
      });
    }
    // console.log(data);
    // console.log(res.data.result);
  } catch (error) {
    // console.log("error", error);
  }
}

export async function getSr(url, symbol, data) {
  // console.log(url, symbol, data);
  symbol = symbol.split("USDT")[0];
  const res = await axios.get(`${hostUrl}/candle/${url}?ticker=${symbol}`);
  const sr_list = res.data.result;
  data.forEach((list) => {
    const { color, title } = setPriceOptions(list.name);
    list["array"] = {
      price: Number(sr_list[list.name]),
      color: color,
      lineWidth: 2,
      lineStyle: 2, // LineStyle.Dashed
      axisLabelVisible: true,
      title: title,
    };
  });
}

export const getTrend = async (symbol) => {
  symbol = symbol.split("USDT")[0];

  try {
    const response = await axios.get(
      `${hostUrl}/analysis/multiple-trend?ticker=${symbol}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getMACDRSI = async (symbol) => {
  symbol = symbol.split("USDT")[0];

  try {
    const response = await axios.get(
      `${hostUrl}/candle/candle-macd?ticker=${symbol}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getHeiMACDRSI = async (symbol) => {
  symbol = symbol.split("USDT")[0];

  try {
    const response = await axios.get(
      `${hostUrl}/candle/heikin-macd?ticker=${symbol}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getRSI = async (symbol) => {
  symbol = symbol.split("USDT")[0];

  try {
    const response = await axios.get(`${hostUrl}/candle/rsi?ticker=${symbol}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

function setPriceOptions(name) {
  let firstChar = name.charAt(0);
  let period = name.slice(-2);
  // console.log(period);
  let title = "";
  let color = "";
  if (firstChar == "h") {
    color = getCssVariableValue("--chart-sr-upper");
  } else {
    color = getCssVariableValue("--chart-sr-lower");
  }
  let text = firstChar == "h" ? "RES" : "SUP";
  if (period == "4w") {
    title = `${text}6`;
  } else if (period == "3w") {
    title = `${text}5`;
  } else if (period == "2w") {
    title = `${text}4`;
  } else if (period == "1w") {
    title = `${text}3`;
  } else if (period == "2d") {
    title = `${text}2`;
  } else if (period == "1d") {
    title = `${text}1`;
  }
  return { color, title };
}

export const getNews = async (symbol, lang) => {
  try {
    let changeLang;
    switch (lang) {
      case "ko":
        changeLang = "kr";
        break;

      case "zh":
      case "vi":
      case "id":
      case "mn":
        changeLang = "en";
        break;

      case "ja":
        changeLang = "jp";
        break;

      default:
        changeLang = lang;
    }

    const res = await axios.get(
      `${devConfig.baseUrl}/analysis/coin-news?ticker=${symbol}&language=${changeLang}&limit=3`
    );

    // 200 상태 코드가 아닌 경우 에러 처리
    if (res.status !== 200) {
      throw new Error(`Error fetching news: ${res.status}`);
    }

    return res.data;
  } catch (error) {
    console.error(error);
  }
};

export const getHighLine = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/candle/high-line?ticker=${kind}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getLowLine = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/candle/low-line?ticker=${kind}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getRlsSignal = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/analysis/rls-signal?ticker=${kind}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getLabelSignal = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/analysis/label-signal?ticker=${kind}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getFilledLineTest = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/candle/filled-line?ticker=${kind}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getSmartLineTest = async (kind) => {
  try {
    const response = await fetch(
      `${devConfig.baseUrl}/candle/smart-line?ticker=${kind}`
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.result;
  } catch (error) {
    console.error("Error fetching markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};

export const getStrategySignal = async (strategy, kind) => {
  try {
    const response = await chartInstance.get(
      `/strategy/signal?strategy=${strategy}&ticker=${kind}`
    );

    let result = response.data.result;

    return result;
  } catch (error) {
    console.error("Error fetching markers:", error);
    throw error; // 에러 다시 던짐 (필요 시)
  }
};
